import axios from 'axios'

// Same BASE_URL as the main panel's service.ts
export const getBaseUrl = () => {
  if (import.meta.env.VITE_API_URL) return import.meta.env.VITE_API_URL;
  
  const { hostname, protocol } = window.location;
  
  // 1. If we are on an IP, use that IP on port 8092
  if (/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(hostname)) {
    return `${protocol}//${hostname}/api/v1`;
  }
  
  // 2. Handle Subdomain access (e.g. http://filemanager.brainwavesvr.com)
  const parts = hostname.split('.');
  if (parts.length >= 2) {
    // If we are on a subdomain (like filemanager or webmail), 
    // the API is likely on the parent domain (e.g. brainwavesvr.com)
    if (parts[0] === 'filemanager' || parts[0] === 'webmail') {
      const parentDomain = parts.slice(1).join('.');
      // Use the parent domain (standard port 443/80 as per your login log)
      return `${protocol}//${parentDomain}/api/v1`;
    }
  }

  // Fallback: talk to the same host but on port 8092
  return `${protocol}//${hostname}/api/v1`;
};

const BASE_URL = getBaseUrl();

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
})

// Read the panel's JWT (panel_jwt) — same key the main panel uses
const getAuthToken = () =>
  localStorage.getItem('fm_token') || localStorage.getItem('panel_jwt') || null

axiosInstance.interceptors.request.use((config) => {
  const token = getAuthToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('fm_token')
      window.dispatchEvent(new Event('fm_unauthorized'))
    }
    return Promise.reject(err.response?.data ?? err)
  }
)

// Same interface as the main panel's service.ts
export const get = async (url, params) => {
  const r = await axiosInstance.get(url, { params })
  return r.data
}

export const post = async (url, data) => {
  const config = data instanceof FormData
    ? { headers: { 'Content-Type': undefined } }
    : {}
  const r = await axiosInstance.post(url, data, config)
  return r.data
}

export const put = async (url, data) => {
  const r = await axiosInstance.put(url, data)
  return r.data
}

export const del = async (url, params) => {
  const r = await axiosInstance.delete(url, { params })
  return r.data
}

export const upload = async (url, formData, onProgress) => {
  const r = await axiosInstance.post(url, formData, {
    headers: { 'Content-Type': undefined },
    onUploadProgress: onProgress,
  })
  return r.data
}

export const setToken   = (t) => localStorage.setItem('fm_token', t)
export const clearToken = ()  => localStorage.removeItem('fm_token')
export const getToken   = ()  => getAuthToken()
export const isLoggedIn = ()  => !!getAuthToken()
